import { withStyles } from "@material-ui/core/styles"
import { Button } from "@material-ui/core"

const style = ({ background = "#606060", color = "white" }) => ({
  root: {
    background: background,
    borderRadius: "25px",
    border: 0,
    color: color,
    height: 55,
    width: 215,
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    fontSize: "20px",
    fontFamily: " Manrope,serif",
    "&:hover": {
      backgroundColor: background,
      boxShadow: "none"
    }
  },
  label: {
    textTransform: "initial",
    fontSize: "20px",
    fontFamily: " Manrope,serif"
  }
})

export const StyledBlackButton = withStyles(style({}))(Button)

export const StyledGreyButton = withStyles(style({ background: "#dcdcdc", color: "#4b4b4b" }))(Button)
